import React from 'react'

export default function CubeGrid() {
  return (
    <div className="sk-cube-grid">
      {[...Array(9)].map((_, idx) => <div key={idx} className={`sk-cube sk-cube${idx + 1}`} />)}
    </div>
  )
}
